export default __webpack_public_path__ + "static/media/img-33.a62a7ea0.jpg";